import type { JSONValue } from "../models/Json";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async (filter: Record<string, JSONValue>) => {
  return httpRequest.get("/prt/employee_unit/select", filter);
};
